<div class="task-details-container p-4">
  <p-toast />

  <div class="mb-3">
    <h3 class="text-primary mb-2">Información de la Tarea</h3>

    <div class="grid">
      <div class="col-12 md:col-6 mb-0">
        <label class="font-semibold text-600">Folio:</label>
        <span class="text-900 ml-2">{{ task?.folio || 'N/A' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Título:</label>
        <span class="text-900 ml-2">{{ task?.title || 'N/A' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Cliente:</label>
        <span class="text-900 ml-2">{{ task?.customer?.name || 'N/A' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Tipo de Tarea:</label>
        <span class="text-900 ml-2">{{ task?.task_type?.name || 'N/A' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Usuario:</label>
        <span class="text-900 ml-2">{{ task?.user?.name || 'N/A' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Fecha Inicial:</label>
        <span class="text-900 ml-2">{{ task?.initial_date | date: 'dd/MM/yyyy' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Fecha Final:</label>
        <span class="text-900 ml-2">{{ task?.final_date | date: 'dd/MM/yyyy' }}</span>
      </div>

      <div class="col-12 md:col-6">
        <label class="font-semibold text-600">Estatus:</label>
        <span [class]="'px-2 py-1 border-round ml-2 ' + getStatusClass(task?.status)">
          {{ task?.status?.name || 'N/A' }}
        </span>
      </div>

      <div class="col-12" *ngIf="task?.description">
        <label class="font-semibold text-600">Descripción:</label>
        <p class="text-900 mt-1 mb-0">{{ task?.description }}</p>
      </div>
    </div>
  </div>

  <div class="grid formgrid mt-3">
    <div class="col-12 md:col-6">
      <p-divider class="p-0 m-0" layout="horizontal" align="center">
        <span class="p-tag">Agregar nueva foto</span>
      </p-divider>

      <div class="grid formgrid mt-3">
        <div class="col-12 mb-3">
          <ngx-dropzone [accept]="'image/*'" (change)="onSelect($event)" [multiple]="false" class="compact-dropzone">
            <ngx-dropzone-label>Arrastra o carga una imagen</ngx-dropzone-label>
          </ngx-dropzone>

          <div class="mt-2" *ngIf="newPhotoFile">
            <div class="photo-preview-container-small">
              <div class="photo-actions">
                <button pButton type="button" icon="pi pi-times"
                  class="p-button-rounded p-button-text p-button-sm delete-button"
                  (click)="onRemoveNewPhoto()"></button>
              </div>
              <img [src]="newPhotoPreview" alt="Preview" class="photo-preview-small">
            </div>
          </div>
        </div>

        <div class="col-12 mb-3">
          <span class="p-fluid">
            <textarea [(ngModel)]="photoComment" placeholder="Comentarios" rows="5" cols="30" pInputTextarea></textarea>
          </span>
        </div>

        <div class="col-12 text-start">
          <button pButton pRipple type="button" label="Subir Foto" icon="pi pi-upload" class="p-button-raised btn-sm"
            [disabled]="!newPhotoFile || !photoComment.trim() || uploadingPhoto" (click)="uploadPhoto()"></button>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <p-divider class="p-0 m-0" layout="horizontal" align="center">
        <span class="p-tag">Fotos de la tarea</span>
      </p-divider>

      <div class="mt-3" *ngIf="photos.length > 0; else noPhotos">
        <p-carousel [value]="photos" [numVisible]="1" [numScroll]="1" [circular]="true" [showNavigators]="true"
          [showIndicators]="true">
          <ng-template let-photo pTemplate="item">
            <div class="carousel-item-container">
              <div class="carousel-photo-wrapper">
                <div class="photo-actions">
                  <button pButton type="button" icon="pi pi-trash"
                    class="p-button-rounded p-button-text p-button-sm delete-button" (click)="deletePhoto(photo)"
                    pTooltip="Eliminar foto" tooltipPosition="left"></button>
                </div>
                <img [src]="photo.photo" [alt]="photo.comment" class="carousel-photo">
              </div>

              <div class="carousel-photo-comment">
                <p class="text-700 mb-0">{{ photo.comment || 'Sin comentario' }}</p>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div>

      <ng-template #noPhotos>
        <div class="text-center p-5">
          <i class="pi pi-image text-400" style="font-size: 3rem;"></i>
          <h4 class="mt-3 text-600">No hay fotos registradas</h4>
          <p class="text-muted">Esta tarea no tiene fotos asociadas aún.</p>
        </div>
      </ng-template>
    </div>
  </div>

  <p-divider class="p-0 m-0 mt-4" layout="horizontal" align="center">
    <span class="p-tag">Historial de Comentarios</span>
  </p-divider>

  <div class="mt-3">
    <div class="mb-4">
      <h5 class="mb-2" style="font-size: 1rem;">Agregar Comentario</h5>
      <div class="grid formgrid">
        <div class="col-12 mb-3">
          <span class="p-fluid">
            <textarea [(ngModel)]="newComment" placeholder="Escribe un comentario sobre la tarea..." rows="3" cols="30"
              pInputTextarea></textarea>
          </span>
        </div>

        <div class="col-12 text-start">
          <button pButton pRipple type="button" label="Agregar Comentario" icon="pi pi-comment"
            class="p-button-raised btn-sm" [disabled]="!newComment.trim() || addingComment"
            (click)="addComment()"></button>
        </div>
      </div>
    </div>

    <div class="comments-container" *ngIf="taskHistory.length > 0; else noComments">
      <div class="comment-item" *ngFor="let comment of taskHistory">
        <div class="comment-header">
          <div class="comment-info">
            <i class="pi pi-user text-primary"></i>
            <span class="comment-author">{{ comment.created_by?.name || 'Usuario' }}</span>
            <span class="comment-date">{{ comment.created_at | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <button pButton type="button" icon="pi pi-trash"
            class="p-button-rounded p-button-text p-button-sm p-button-danger" (click)="deleteComment(comment)"
            pTooltip="Eliminar comentario" tooltipPosition="left"></button>
        </div>

        <div class="comment-body">
          <p class="comment-text">{{ comment.comments }}</p>

          <div class="comment-actions">
            <button pButton type="button"
              [label]="expandedCommentId === comment.id ? 'Ocultar fotos' : 'Ver/Agregar fotos'" icon="pi pi-images"
              class="p-button-text p-button-sm" (click)="toggleCommentPhotos(comment.id)"></button>
          </div>

          <div class="comment-photos-section" *ngIf="expandedCommentId === comment.id">
            <div class="grid formgrid mt-2">
              <div class="col-12 md:col-6">
                <h6 class="mb-2">Agregar Foto al Comentario</h6>
                <ngx-dropzone [accept]="'image/*'" (change)="onSelectCommentPhoto($event, comment.id)"
                  [multiple]="false" class="compact-dropzone">
                  <ngx-dropzone-label>Arrastra o carga una imagen</ngx-dropzone-label>
                </ngx-dropzone>

                <div class="mt-2" *ngIf="newCommentPhotoFile[comment.id]">
                  <div class="photo-preview-container-small">
                    <div class="photo-actions">
                      <button pButton type="button" icon="pi pi-times"
                        class="p-button-rounded p-button-text p-button-sm delete-button"
                        (click)="onRemoveCommentPhoto(comment.id)"></button>
                    </div>
                    <img [src]="newCommentPhotoPreview[comment.id]" alt="Preview" class="photo-preview-small">
                  </div>
                </div>

                <div class="mt-2">
                  <span class="p-fluid">
                    <textarea [(ngModel)]="commentPhotoComment[comment.id]" placeholder="Comentario (opcional)" rows="2"
                      cols="30" pInputTextarea></textarea>
                  </span>
                </div>

                <div class="mt-2">
                  <button pButton pRipple type="button" label="Subir Foto" icon="pi pi-upload"
                    class="p-button-raised btn-sm"
                    [disabled]="!newCommentPhotoFile[comment.id] || uploadingCommentPhoto[comment.id]"
                    (click)="uploadCommentPhoto(comment.id)"></button>
                </div>
              </div>

              <div class="col-12 md:col-6">
                <h6 class="mb-2">Fotos del Comentario</h6>
                <div *ngIf="commentPhotos && commentPhotos[comment.id] && commentPhotos[comment.id].length > 0; else noCommentPhotos">
                  <p-carousel [value]="commentPhotos[comment.id]" [numVisible]="1" [numScroll]="1" [circular]="true"
                    [showNavigators]="true" [showIndicators]="true">
                    <ng-template let-photo pTemplate="item">
                      <div class="carousel-item-container comment-carousel">
                        <div class="carousel-photo-wrapper-small">
                          <div class="photo-actions">
                            <button pButton type="button" icon="pi pi-trash"
                              class="p-button-rounded p-button-text p-button-sm delete-button"
                              (click)="deleteCommentPhoto(photo, comment.id)" pTooltip="Eliminar foto"
                              tooltipPosition="left"></button>
                          </div>
                          <img [src]="photo.photo" [alt]="photo.comment" class="carousel-photo-small">
                        </div>
                        <div class="carousel-photo-comment" *ngIf="photo.comment">
                          <p class="text-700 mb-0">{{ photo.comment }}</p>
                        </div>
                      </div>
                    </ng-template>
                  </p-carousel>
                </div>

                <ng-template #noCommentPhotos>
                  <div class="text-center p-3">
                    <i class="pi pi-image text-400" style="font-size: 2rem;"></i>
                    <p class="mt-2 text-600">Sin fotos</p>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center mt-3"
        *ngIf="historyPagination.page * historyPagination.page_size < historyPagination.total">
        <button pButton pRipple type="button" label="Cargar más comentarios" icon="pi pi-refresh"
          class="p-button-outlined btn-sm" [disabled]="historyPagination.loading" (click)="loadMoreComments()"></button>
      </div>

      <div class="text-center mt-3" *ngIf="historyPagination.loading">
        <i class="pi pi-spinner pi-spin"></i> Cargando comentarios...
      </div>
    </div>

    <ng-template #noComments>
      <div class="text-center p-5">
        <i class="pi pi-comments text-400" style="font-size: 3rem;"></i>
        <h4 class="mt-3 text-600">No hay comentarios</h4>
        <p class="text-muted">Aún no se han agregado comentarios a esta tarea.</p>
      </div>
    </ng-template>
  </div>

  <div class="text-center mt-4">
    <button (click)="close()" pButton pRipple type="button" label="Cerrar" icon="pi pi-times"
      class="p-button-raised p-button-secondary btn-sm"></button>
  </div>
</div>